import { Instance as SummaryInstance } from '../types';

export const buildPatchFieldBody = (
  instance: SummaryInstance,
  field_id: string,
  ignore: boolean = true,
) => {
  const changes: any = {};
  const undo_changes: any = {};
  changes[instance.id] = field_id;
  undo_changes[instance.id] = field_id;

  if (ignore) return { changes, undo_changes };

  changes[instance.id] = field_id;
  changes[instance.id] = field_id;
  changes['existingInstanceId'] = instance.id;
  changes['newInstanceId'] = field_id;
  undo_changes[instance.id] = field_id;
  undo_changes[instance.id] = field_id;

  return { changes, undo_changes };
};
